import { PaymentStatus } from 'Model/Payment/PaymentStatus';

export const PAYMENT_STATUS_COLORS: Record<PaymentStatus, string> = {
    [PaymentStatus.PENDING]: 'warning',
    [PaymentStatus.AUTHORIZED]: 'success',
    [PaymentStatus.FAILED]: 'danger',
    [PaymentStatus.REFUNDED]: 'primary',
};
